var e;!function(e){e.HeaderTestId="CorvaUI.AppContainer.HeaderTestId",e.ContentTestId="CorvaUI.AppContainer.ContentTestId",e.FooterTestId="CorvaUI.AppContainer.FooterTestId"}(e||(e={}));export{e as AppContainerTestIds};
